<template>
    <form class="form form--contact" method="post" @submit.prevent="submitForm($event)" id="formRequestDocument" autocomplete="off">
  
      <Modal v-model="showModal" :title="formTitle" :status="formSuccess" :message="formMessage" @close="resetModal" template="requestDocument" />
  
      <div class="row">
        <div class="col-sm-12">
            <div class="form-group">
                <label class="form-label" for="fullname">{{ translate("name.of.shareholder") }}*</label>
                <input class="form-control" type="text" name="fullname" id="fullname" maxlength="100" value="" required>
            </div>
        </div>
        <div class="col-sm-6">
            <div class="form-group">
                <label class="form-label" for="telephone">{{ translate("telephone") }}</label>
                <input type="tel" class="form-control" id="telephone" name="telephone" maxlength="20" value="">
            </div>
        </div>
        <div class="col-sm-6">
          <div class="form-group">
            <label class="form-label" for="email">{{ translate("email") }}</label>
            <input class="form-control" type="text" id="email" name="email" maxlength="50" value="">
          </div>
        </div>
        <div class="col-12">
          <div class="form-group">
            <label class="form-label">{{ translate("please.select.the.desired.document") }}*</label>
          </div>
        </div>
        <div class="row">
            <div class="col-sm-4">
                <div class="form-group">
                    <div class="custom-control custom-checkbox">
                        <input class="custom-control-input" type="checkbox" id="lang_thai" name="doc_langs[]" value="ภาษาไทย">
                        <label class="custom-control-label" for="lang_thai">{{ translate("thai.version") }}</label>
                    </div>
                </div>
            </div>
            <div class="col-sm-4">
                <div class="form-group">
                    <div class="custom-control custom-checkbox">
                        <input class="custom-control-input" type="checkbox" id="lang_eng" name="doc_langs[]" value="ภาษาอังกฤษ">
                        <label class="custom-control-label" for="lang_eng">{{ translate("eng.version") }}</label>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-4">
            <div class="form-group">
                <div class="custom-control custom-checkbox">
                    <input class="custom-control-input" type="checkbox" id="one_report" name="doc_types[]" value="แบบ 56-1 One Report">
                    <label class="custom-control-label" for="one_report">{{ translate("one.report") }}</label>
                </div>
            </div>
            </div>
            <div class="col-md-4">
            <div class="form-group">
                <div class="custom-control custom-checkbox">
                    <input class="custom-control-input" type="checkbox" id="sd_report" name="doc_types[]" value="รายงานการพัฒนาอย่างยั่งยืน">
                    <label class="custom-control-label" for="sd_report">{{ translate("sustainable.development.report") }}</label>
                </div>
            </div>
            </div>
            <div class="col-md-4">
            <div class="form-group">
                <div class="custom-control custom-checkbox">
                    <input class="custom-control-input" type="checkbox" id="proxy_form" name="doc_types[]" value="แบบฟอร์มการมอบฉันทะ แบบ ข.">
                    <label class="custom-control-label" for="proxy_form">{{ translate("proxy.form.b") }}</label>
                </div>
            </div>
            </div>
        </div>
        <div class="col-12">
          <div class="form-group">
            <label class="form-label">{{ translate("address.for.sending.documents") }}</label>
          </div>
        </div>
        <div class="col-sm-4">
            <div class="form-group">
                <label class="form-label" for="house_number">{{ translate("house.number") }}*</label>
                <input class="form-control" type="text" name="house_number" id="house_number" maxlength="10" value="" required>
            </div>
        </div>
        <div class="col-sm-4">
            <div class="form-group">
                <label class="form-label" for="village_number">{{ translate("village.number") }}*</label>
                <input class="form-control" type="text" name="village_number" id="village_number" maxlength="100" value="" required>
            </div>
        </div>
        <div class="col-sm-4">
            <div class="form-group">
                <label class="form-label" for="village">{{ translate("village") }}*</label>
                <input class="form-control" type="text" name="village" id="village" maxlength="100" value="" required>
            </div>
        </div>
        <div class="col-sm-6">
            <div class="form-group">
                <label class="form-label" for="alley">{{ translate("alley") }}*</label>
                <input class="form-control" type="text" name="alley" id="alley" maxlength="100" value="" required>
            </div>
        </div>
        <div class="col-sm-6">
            <div class="form-group">
                <label class="form-label" for="road">{{ translate("road") }}*</label>
                <input class="form-control" type="text" name="road" id="road" maxlength="100" value="" required>
            </div>
        </div>
        <div class="col-sm-6">
            <div class="form-group">
                <label class="form-label" for="sub_district">{{ translate("sub.district") }}*</label>
                <input class="form-control" type="text" name="sub_district" id="sub_district" maxlength="100" value="" required>
            </div>
        </div>
        <div class="col-sm-6">
            <div class="form-group">
                <label class="form-label" for="district">{{ translate("district") }}*</label>
                <input class="form-control" type="text" name="district" id="district" maxlength="100" value="" required>
            </div>
        </div>
        <div class="col-sm-6">
            <div class="form-group">
                <label class="form-label" for="province">{{ translate("province") }}*</label>
                <input class="form-control" type="text" name="province" id="province" maxlength="100" value="" required>
            </div>
        </div>
        <div class="col-sm-6">
            <div class="form-group">
                <label class="form-label" for="postcode">{{ translate("postcode") }}*</label>
                <input class="form-control" type="text" name="postcode" id="postcode" maxlength="10" value="" required>
            </div>
        </div>
  
        
        <div class="col-12">
          <div class="form__block mt-2">
              <div class="custom-control custom-checkbox">
                  <input 
                  type="checkbox" 
                  class="custom-control-input" 
                  name="privacyStatement"
                  v-model="isChecked"
                  @change="handleCheckboxChange"
                  >
                  <label class="custom-control-label" v-html="translate('privacy.statement.document.request.text')"></label>
              </div>
    
              <div class="form__btn">
                  <button 
                      type="submit" 
                      class="btn btn--secondary" 
                      :disabled="!isChecked"
                      >
                      <span class="btn__title">{{ translate("submit") }}</span>
                  </button>
              </div>
          </div>
        </div>
  
        
      </div>
    </form>
  </template>
  
  <script setup>
  import { ref } from 'vue';
  import { useFormDocumentContact } from "@/composables/useFormDocumentContact";
  import Modal from "@/components/helpers/Modal.vue";
  import Loading from "@/components/helpers/Loading.vue";
  
  const isChecked = ref(false)
  
  const props = defineProps({
    posts: {
      type: Object,
      required: true,
    },
  });
  
  // ใช้ Composable
  const {
    isLoading,
    LoadingTitle,
    formSuccess,
    formTitle,
    formMessage,
    showModal,
    privacyStatement,
    submitForm,
    resetModal,
    translate,
  } = useFormDocumentContact();
  </script>
  
  <style lang="scss" scoped></style>
